exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn.mb-2.float-filter.btn-secondary.btn-sm.collapsed{position:fixed;top:35%;text-align:center;z-index:100}.search-filter{border-radius:20px;border:1px solid #ddd;height:30px;width:200px;font-size:12px;margin-right:50px;text-align:left;padding:0 30px 0 12px;outline:none}", ""]);

// exports
